import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';

import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';
import { UserMetric } from 'types/user_metric';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseUserMetricsOptions = UseQueryOptions<
  OffsetPaginated<UserMetric>,
  APIError
> & { params?: OffsetPaginationParams };

export function useUserMetrics({
  queryKey = ['user-metrics'],
  params,
  // Metrics rarely change
  staleTime = Infinity,
  cacheTime = Infinity,
  refetchOnWindowFocus = false,
  ...options
}: UseUserMetricsOptions = {}) {
  const { applicationID, client } = useAPI();

  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 150,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, queryParams],
    async () => {
      const { data } = await client.get<OffsetPaginated<UserMetric>>(
        `/apps/${applicationID}/user_metrics`,
        {
          params: queryParams,
        }
      );

      return data;
    },
    {
      staleTime,
      cacheTime,
      refetchOnWindowFocus,
      ...options,
    }
  );
}
